export default __webpack_public_path__ + "static/media/venadoDeColaBlanca.b7270fb8.jpg";